go-content {
  /**
    @prop --iframe-embed-aspect-ratio:
      Aspect ratio for iframe content
      - default: 16/9
  */
  --iframe-embed-aspect-ratio: 16/9;
  > * + *,
  go-md > * + * {
    margin-top: 1.5em;
  }
  figure {
    margin: 0;
  }
  figcaption {
    text-align: center;
  }

  img,
  video {
    max-width: 100%;
    width: 100%;
    @include tablet {
      width: auto;
    }
  }
  iframe {
    width: 100%;
    height: unset;
    aspect-ratio: var(--iframe-embed-aspect-ratio);
  }
  table {
    width: 100%;
  }
  kbd {
    padding: 0.25em 0.5em;
    border-radius: var(--radius-2);
    background-color: var(--go-color-code-bg);
    color: var(--go-color-code-fg);
    box-shadow: var(--shadow-1);
  }
}
